import React, { createRef, useEffect, useState } from "react";
import { bool, node, string } from "prop-types";

import Portal from "src/shared/components/Portal";

import {
  findMountPoint,
  useStickyContainer
} from "../../utilities/stickyHelpers";
import * as S from "./styled";

const StickyBannerContainer = ({
  backgroundColor,
  children,
  className,
  hasTransitions,
  isAtTopOfScreen,
  isMobile,
  isOnTopOfContent
}) => {
  const containerRef = createRef();
  const [mountContainer, setMountContainer] = useState(containerRef.current);
  const [mountPoint, setMountPoint] = useState(
    findMountPoint({ isMobile, isOnTopOfContent })
  );

  useStickyContainer(isMobile, mountContainer);

  useEffect(() => {
    setMountContainer(containerRef.current);
  }, [containerRef, isMobile]);

  useEffect(() => {
    setMountPoint(findMountPoint({ isMobile, isOnTopOfContent }));
  }, [isMobile]);

  return (
    <Portal
      mountPoint={mountPoint}
      portalElementId={`stickyContainer${isMobile ? "Mobile" : ""}`}
    >
      <S.Container
        ref={containerRef}
        backgroundColor={backgroundColor}
        className={className}
        hasTransitions={hasTransitions}
        isAtTopOfScreen={isAtTopOfScreen}
        isMobile={isMobile}
        isOnTopOfContent={isOnTopOfContent}
      >
        {children}
      </S.Container>
    </Portal>
  );
};

StickyBannerContainer.propTypes = {
  children: node.isRequired,
  className: string,
  isMobile: bool,
  hasTransitions: bool,
  backgroundColor: string,
  isAtTopOfScreen: bool,
  isOnTopOfContent: bool
};

StickyBannerContainer.defaultProps = {
  isMobile: false,
  className: "",
  hasTransitions: true,
  backgroundColor: "transparent",
  isAtTopOfScreen: false,
  isOnTopOfContent: false
};

export default StickyBannerContainer;
